import { useTranslation } from 'react-i18next';
import { SampleDetails } from '@components/sample-details/SampleDetails';
import { useSample } from '@hooks/useSample';
import { ConfigurationProvider } from '@src/providers/ConfigurationProvider.tsx';
import { SampleDetailsDto } from '@src/types/types.ts';
import { useConfigurationContext } from '@hooks/useConfiguration.tsx';

export const Result = () => {
  const { data, isLoading } = useSample();
  return (
    <ConfigurationProvider>
      <LoadingOrSampleDetails
        isLoading={isLoading}
        data={data as SampleDetailsDto}
      />
    </ConfigurationProvider>
  );
};

const LoadingOrSampleDetails = ({
  isLoading,
  data,
}: {
  isLoading: boolean;
  data: SampleDetailsDto;
}) => {
  const { configuration, isLoading: configIsLoading } =
    useConfigurationContext();

  const { t } = useTranslation('view', { keyPrefix: 'result' });
  return (
    <>
      {(isLoading || configIsLoading) && <p>{t('loading')}</p>}
      {data && configuration && (
        <SampleDetails sample={data} config={configuration!} />
      )}
    </>
  );
};
